<script setup>
import { Head, Link, useForm } from "@inertiajs/vue3";
import VDevider from "@/Shared/VDevider.vue";
import VTitleWithBackLink from "@/Shared/VTitleWithBackLink.vue";
import VHeaderBreadcrumb from "@/Shared/VHeaderBreadcrumb.vue";
import {
    listTabDepartingVisitor,
    listTabSabahOutbound,
} from "@/Pages/PublicPage/Survey/tabs.config";
import VFormDeparting from "./_partials/VFormDeparting.vue";
import VFormOutbound from "./_partials/VFormOutbound.vue";

import { useLangStore } from "@/Store/language";

const props = defineProps({
    title: String,
    additional: Object,
});

const TYPE_SURVEY_DEPARTING = "departing-visitor-survey";
const TYPE_SURVEY_OUTBOUND = "sabah-outbound-survey";

const { questionnaire, surveyFields, urlIndex, urlCategory, tabCodeActive } =
    props.additional;

const tabs =
    questionnaire.code == TYPE_SURVEY_DEPARTING
        ? listTabDepartingVisitor
        : listTabSabahOutbound;

const activeTab = tabs.find((item) => item.key == tabCodeActive);

const breadcrumbs = [
    {
        url: urlIndex,
        label: "Questionnaire",
    },
    {
        url: urlCategory,
        label: questionnaire.name,
    },
    {
        url: "#",
        label: activeTab?.title,
    },
];

const langStore = useLangStore();

langStore.setLang("en");
</script>

<template>
    <Head>
        <title>{{ title }}</title>
    </Head>

    <div class="p-3">
        <VHeaderBreadcrumb :breadcrumbs="breadcrumbs" />

        <div class="card">
            <div class="card-body">
                <div class="d-flex justify-content-between">
                    <VTitleWithBackLink :href="urlCategory">
                        {{ activeTab?.title }}
                    </VTitleWithBackLink>
                </div>

                <VDevider />
                <div class="row">
                    <div class="col-md-12">
                        <component
                            :is="
                                questionnaire.code == TYPE_SURVEY_DEPARTING
                                    ? VFormDeparting
                                    : VFormOutbound
                            "
                            :tab="activeTab"
                            :surveyFields="surveyFields"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
